



import React, { useState } from "react";

const PasswordForm = () => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [message, setMessage] = useState("\u00A0");
  const [isMatch, setIsMatch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiMessage, setApiMessage] = useState("");

  // Use your token here
  const token = "7dd03426-fd0b-4574-b557-fa38cda1c75a";

  const checkPasswords = (pw, cf) => {
    if (pw.length === 0 && cf.length === 0) {
      setMessage("\u00A0");
      setIsMatch(false);
      return;
    }
    if (pw.length < 6) {
      setMessage("Password must contain at least 6 characters.");
      setIsMatch(false);
      return;
    }
    if (pw === cf) {
      setMessage("Passwords match.");
      setIsMatch(true);
    } else {
      setMessage("Passwords do not match.");
      setIsMatch(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isMatch) return;

    setLoading(true);
    setApiMessage("");

    try {
      const response = await fetch(
        `https://backend.maamaas.com/food/forgot/reset/${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            newPassword: password,
            confirmPassword: confirm,
          }),
        }
      );

      let data;
      const text = await response.text();

      try {
        data = JSON.parse(text); // Try parsing JSON
      } catch {
        data = { message: text }; // fallback if plain text
      }

      if (response.ok) {
        setApiMessage(data.message || "Password has been reset successfully!");
        setPassword("");
        setConfirm("");
        setIsMatch(false);
      } else {
        setApiMessage(data.message || "Something went wrong!");
      }
    } catch (err) {
      console.error(err);
      setApiMessage("Network error. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>


      <div className="wrap">
        <div className="card">
          <h1>Create a Secure Password</h1>
          <p className="lead">Please enter and confirm your password. The submit button will only be enabled if both entries match.</p>

          <form onSubmit={handleSubmit}>
            <div className="field">
              <label htmlFor="password">Password</label>
              <div className="input-row">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    checkPasswords(e.target.value, confirm);
                  }}
                  placeholder="Enter your password"
                  required
                  minLength="6"
                />
                <button type="button" className="toggle-btn" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            <div className="field">
              <label htmlFor="confirm">Confirm Password</label>
              <div className="input-row">
                <input
                  id="confirm"
                  type={showConfirm ? "text" : "password"}
                  value={confirm}
                  onChange={(e) => {
                    setConfirm(e.target.value);
                    checkPasswords(password, e.target.value);
                  }}
                  placeholder="Re-enter your password"
                  required
                  minLength="6"
                />
                <button type="button" className="toggle-btn" onClick={() => setShowConfirm(!showConfirm)}>
                  {showConfirm ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            <div className={"help " + (isMatch ? "ok" : "")}>{message}</div>
            <button type="submit" disabled={!isMatch || loading}>{loading ? "Submitting..." : "Submit"}</button>
            <div className="api-message">{apiMessage}</div>
          </form>
        </div>
      </div>
    </>
  );
};

export default PasswordForm;
